// @ts-nocheck
import { hubService } from '@/services';
export default {
    // 라이더 관리 배차 취소 패널티 그룹 (C,R,U,D)
    /**
     * 라이더 관리 배차 취소 패널티 그룹 생성
     */
    async postWorkerAllocatedCancelPenaltyGroup({ commit, rootGetters }, payload = {}) {
        const hubId = rootGetters['hubSelector/getterSubscribeHubId'];
        const response = await hubService.postWorkerAllocatedCancelPenaltyGroup({
            hubId,
            payload,
        });
        commit('POST_WORKER_ALLOCATED_CANCEL_PENALTY_GROUP', response.data);
    },
    /**
     * 라이더 관리 배차 취소 패널티 그룹 조회
     */
    async getWorkerAllocatedCancelPenaltyGroupList({ commit, rootGetters }) {
        // 상세 및 수정 페이지에서는 허브셀렉트 박스가 아닌 선택된 라이더의 허브를 기준으로 작동합니다.
        const selectedWorkerHubId = rootGetters['workerManagement/workerEdit/getterSelectedWorkerHubId'];
        const hubId = selectedWorkerHubId ?? rootGetters['hubSelector/getterSubscribeHubId'];
        const response = await hubService.getWorkerAllocatedCancelPenaltyGroup({
            hubId,
        });
        const workerEditGroup = rootGetters['workerManagement/workerEdit/getterSelectedWorkerDetailAllocatedCancelPenaltyGroup'];
        // 라이더 수정 시 현재 소속 그룹 최상단
        if (workerEditGroup) {
            response.data = response.data
                .filter((group) => group.id !== workerEditGroup.id);
            response.data.unshift(workerEditGroup);
        }
        commit('GET_WORKER_ALLOCATED_CANCEL_PENALTY_GROUP_LIST', response.data);
    },
    /**
     * 라이더 관리 배차 취소 패널티 그룹 수정
     */
    async putWorkerAllocatedCancelPenaltyGroup({ commit, rootGetters }, payload = {}) {
        const hubId = rootGetters['hubSelector/getterSubscribeHubId'];
        const { groupId = '' } = payload;
        const response = await hubService.putWorkerAllocatedCancelPenaltyGroup({
            hubId,
            id: groupId,
            payload,
        });
        commit('PUT_WORKER_ALLOCATED_CANCEL_PENALTY_GROUP', response.data);
    },
    /**
     * 라이더 관리 배차 취소 패널티 그룹 삭제
     */
    async deleteWorkerAllocatedCancelPenaltyGroup({ state, commit, rootGetters }, payload = {}) {
        const hubId = rootGetters['hubSelector/getterSubscribeHubId'];
        const { groupId = '' } = payload;
        const response = await hubService.deleteWorkerAllocatedCancelPenaltyGroup({
            hubId,
            id: groupId,
        });
        if (!response.data.isSuccess) {
            return;
        }
        const deletedPenaltyGroupList = state.workerAllocatedCancelPenaltyGroupList
            .filter((group) => group.id !== groupId);
        commit('DELETE_WORKER_ALLOCATED_CANCEL_PENALTY_GROUP', deletedPenaltyGroupList);
        commit('PUBLISH_WORKER_ALLOCATED_CANCEL_PENALTY_GROUP_DELETED', groupId);
    },
    // 라이더 관리 배차취소 패널티 설정 (R,U) C, D는 정책상 없음
    /**
     * 라이더 관리 배차취소 패널티 설정 조회
     */
    async getWorkerAllocatedCancelPenaltyGroupOptionList({ commit, rootGetters }, payload = {}) {
        // 상세 및 수정 페이지에서는 허브셀렉트 박스가 아닌 선택된 라이더의 허브를 기준으로 작동합니다.
        const selectedWorkerHubId = rootGetters['workerManagement/workerEdit/getterSelectedWorkerHubId'];
        const hubId = selectedWorkerHubId ?? rootGetters['hubSelector/getterSubscribeHubId'];
        const { groupId = '' } = payload;
        const response = await hubService.getWorkerAllocatedCancelPenaltyGroupDetail({
            hubId,
            groupId,
        });
        commit('GET_WORKER_ALLOCATED_CANCEL_PENALTY_GROUP_OPTION_LIST', response.data);
    },
    /**
     * 라이더 관리 배차취소 패널티 설정 수정
     */
    async putWorkerAllocatedCancelPenaltyGroupOption({ commit, rootGetters }, payload = {}) {
        const hubId = rootGetters['hubSelector/getterSubscribeHubId'];
        const { groupId = '', optionId = '' } = payload;
        const response = await hubService.putWorkerAllocatedCancelPenaltyGroupDetail({
            hubId,
            groupId,
            id: optionId,
            payload,
        });
        commit('PUT_WORKER_ALLOCATED_CANCEL_PENALTY_GROUP_OPTION', response.data);
    },
    setSelectedPenaltyGroup({ commit }, group = {}) {
        commit('SET_SELECTED_PENALTY_GROUP', group);
    },
    // 다이얼로그 핸들링
    setOpenEditGroupDialog({ commit }, isOpen = true) {
        commit('SET_OPEN_EDIT_GROUP_DIALOG', isOpen);
    },
    setOpenEditOptionDialog({ commit }, isOpen = true) {
        commit('SET_OPEN_EDIT_OPTION_DIALOG', isOpen);
    },
    setEditGroupItem({ commit }, item = {}) {
        commit('SET_EDIT_GROUP_ITEM', item);
    },
    setEditOptionItem({ commit }, item = {}) {
        commit('SET_EDIT_OPTION_ITEM', item);
    },
    // 초기화
    clearAllocatedCancelPenaltyGroupDialog({ commit }) {
        commit('CLEAR_WORKER_ALLOCATED_CANCEL_PENALTY_GROUP_LIST');
        commit('CLEAR_WORKER_ALLOCATED_CANCEL_PENALTY_GROUP_OPTION_LIST');
        commit('CLEAR_SELECTED_PENALTY_GROUP');
    },
    clearWorkerAllocatedCancelPenaltyGroupList({ commit }) {
        commit('CLEAR_WORKER_ALLOCATED_CANCEL_PENALTY_GROUP_LIST');
    },
    clearWorkerAllocatedCancelPenaltyGroupOptionList({ commit }) {
        commit('CLEAR_WORKER_ALLOCATED_CANCEL_PENALTY_GROUP_OPTION_LIST');
    },
    clearSelectedPenaltyGroup({ commit }) {
        commit('CLEAR_SELECTED_PENALTY_GROUP');
    },
    setOpenPenaltyGroupSelectDialog({ commit }, isOpen = true) {
        commit('SET_OPEN_PENALTY_GROUP_SELECT_DIALOG', isOpen);
    },
};
